import React from 'react';
import styles from './Label.module.scss';

const Label = ({
  text,
  isCursor,
  style,
  htmlFor,
  classname,
  required,
  disabled,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`${styles.label} ${isCursor ? styles.hover : ''} ${
        classname ?? ''
      } ${disabled ? styles.disabled : ''}`}
      style={style}
    >
      {text} {required ? <span style={{ color: 'red' }}>*</span> : null}
    </label>
  );
};

export default Label;
